export const equipmentFieldForDisplayTranslation = {
  license_plate: 'Placa do veículo',
  chassis_number: 'Chassi',
  renavam: 'Renavam',
  serial_number: 'Número de série',
  official_name: 'Nome',
  display_name: 'Nome do fabricante',
}
